import React from "react";
import HC from "@material-ui/icons/HomeOutlined";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";

const useBreadcrumbsHomeIconStyles = makeThemedStyles(
  "Breadcrumbs.HomeIcon",
  (theme) => ({
    root: {
      width: "20px",
      height: "20px",
      color: "rgba(255, 255, 255, 0.5)",
      "&:hover": { color: "rgba(255, 255, 255, 0.8)" },
    },
  })
);

const HomeIcon = () => {
  const classes = useBreadcrumbsHomeIconStyles();
  return <HC classes={classes} />;
};

export default HomeIcon;
